import { Fragment, useEffect, useState } from "react";
import plus from "../../../../assets/icons/plus.svg";
import info from "../../../../assets/icons/info-circle-white.svg";
import deleteIcon from "../../../../assets/icons/delete.png";
import * as Library from "../../../../utils/Library";
import useApiSteps from "../../../../utils/hooks/useApiSteps";
import FormField from "../../../common/forms/FormField";
import {
    authCategories,
    authTypeEnums,
    calledFromEnums,
    commonFieldOptionEnums,
    fieldNameEnums
} from "../apiPageHelper";
import { StepFormStyle } from "../ApiPage";
import ArrayFields from "./ArrayFields";

const AuthorizationPopup = ({
    handleAuthChange,
    authDetails,
    handleOpenConnectedFieldModal,
    connectedFieldOptions,
    registerYesHandler,
    posID,
    environmentName,
    handleGetAuthorizationsData,
    resetAuthDetails,
    setLoading,
    formValidHandler
}) => {
    // #region STATES

    const [authTypes] = useState([
        { name: "No Auth", value: "No Auth", selected: false },
        { name: "Bearer Token", value: "Bearer Token", selected: false }
    ]);

    const [dataTypes] = useState([
        { value: "String", name: "String" },
        { value: "Number", name: "Number" },
        {
            value: "Boolean",
            name: "Boolean"
        },
        {
            value: "Array Fields",
            name: "Array Fields"
        }
    ]);
    // #endregion

    // #region computed vars
    const {
        steps,
        addField,
        updateField,
        getFieldsByCategory,
        removeField,
        getFilteredSteps,
        useFormValidation,
        updateArraySubField,
        removeArraySubField,
        getEndpointFields
    } = useApiSteps({
        connectedFieldOptions,
        endpointOptions: []
    });
    const searchParams = new URLSearchParams(window.location.search);
    const apiName = searchParams.get("apiName");
    const isFormValid = useFormValidation(steps, true);
    const { inputFields = [], outputFields = [] } = getEndpointFields(apiName);
    // #endregion

    // #region METHODS
    const filteredSteps = getFilteredSteps({ steps });

    registerYesHandler(async () => {
        const step = filteredSteps[0];
        const authorizationFieldsData = {};

        if (step.headerFields?.length > 0) {
            authorizationFieldsData.headerFields = step.headerFields;
        }
        if (step.paramsFields?.length > 0) {
            authorizationFieldsData.paramsFields = step.paramsFields;
        }
        if (step.bodyFields?.length > 0) {
            authorizationFieldsData.bodyFields = step.bodyFields;
        }

        Library.makeApiRequest({
            data: {
                authorizationData: { ...authDetails, ...authorizationFieldsData },
                posID,
                environmentName
            },
            endpoint: "createAuthorization",
            setLoader: setLoading
        }).then(res => {
            if (res?.data?.status === 200) {
                handleGetAuthorizationsData();
                resetAuthDetails();
                Library.showToastMessage({
                    type: "success",
                    title: "Authorization has been created!"
                });
            }
        });
    });
    // #endregion

    // #region  EFFECTS
    useEffect(() => {
        formValidHandler(isFormValid);
    }, [isFormValid]);
    // #endregion

    return steps?.map((step, stepIndex) => {
        return (
            <StepFormStyle key={stepIndex}>
                <FormField
                    type="text"
                    title="Authorization Name"
                    tooltip="Authorization Name"
                    requiredType="mandatory"
                    assistiveText=""
                    varName="name"
                    value={authDetails?.name}
                    onTextChange={e => {
                        handleAuthChange("name", e);
                    }}
                />
                <FormField
                    type="dropdown"
                    title="Type"
                    tooltip="Type"
                    dropdownData={authTypes}
                    requiredType="mandatory"
                    value={authDetails?.type}
                    onTextChange={e => {
                        handleAuthChange("type", e.value);
                    }}
                    assistiveText=""
                    varName="type"
                />
                {authDetails?.type === authTypeEnums.NO_AUTH && (
                    <div className="frame-100001139010">
                        {Object.entries(authCategories).map(([category, label]) => {
                            const fields = getFieldsByCategory(step, category);
                            return (
                                <div className="frame-1000011384">
                                    <div className="frame-1000011382">
                                        <div className="frame-295922385">
                                            <div className="frame-295922380">
                                                <div className="frame-161">
                                                    <div className="frame-296">
                                                        <div className="header-fields">{label}</div>
                                                        <img className="info-circle9" src={info} alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="frame-2959223813">
                                                <div className="frame-271">
                                                    <div className="frame-291">
                                                        <div className="frame-171">
                                                            <div className="frame-144"></div>
                                                        </div>
                                                    </div>
                                                    <div className="frame-1588">
                                                        {fields?.map(field => {
                                                            const mergedOptions = [
                                                                ...(inputFields?.map(f => ({
                                                                    value: f.value,
                                                                    name: f.value
                                                                })) || []),
                                                                ...(outputFields?.map(f => ({
                                                                    value: f.value,
                                                                    name: f.value
                                                                })) || []),
                                                                ...(field?.options?.filter(
                                                                    opt =>
                                                                        opt?.label !== commonFieldOptionEnums.CONNECTED
                                                                ) || [])
                                                            ];

                                                            const uniqueOptions = Array.from(
                                                                new Map(
                                                                    mergedOptions.map(opt => [opt.value, opt])
                                                                ).values()
                                                            );
                                                            return (
                                                                <Fragment key={field.id}>
                                                                    <div
                                                                        className={`${
                                                                            field?.value === "Predefined"
                                                                                ? "frame-902"
                                                                                : "frame-901"
                                                                        } p-relative`}>
                                                                        <div className="dropdown-selector2">
                                                                            <FormField
                                                                                type="dropdown"
                                                                                title="Type"
                                                                                tooltip="Type"
                                                                                dropdownData={dataTypes}
                                                                                value={field.type}
                                                                                requiredType={"mandatory"}
                                                                                assistiveText=""
                                                                                varName="type"
                                                                                onTextChange={e => {
                                                                                    updateField(
                                                                                        stepIndex,
                                                                                        field.id,
                                                                                        "type",
                                                                                        e?.value
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="simple">
                                                                            <FormField
                                                                                type="text"
                                                                                title="Name"
                                                                                tooltip="Name"
                                                                                requiredType={"mandatory"}
                                                                                assistiveText=""
                                                                                varName="name"
                                                                                value={field?.name}
                                                                                onTextChange={e =>
                                                                                    updateField(
                                                                                        stepIndex,
                                                                                        field.id,
                                                                                        "name",
                                                                                        e
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="dropdown-selector2">
                                                                            <FormField
                                                                                className="w-100"
                                                                                type="dropdown"
                                                                                title="Value"
                                                                                tooltip="Value"
                                                                                dropdownData={[
                                                                                    ...(inputFields?.map(f => ({
                                                                                        value: f.value,
                                                                                        name: f.value
                                                                                    })) || []),
                                                                                    ...(outputFields?.map(f => ({
                                                                                        value: f.value,
                                                                                        name: f.value
                                                                                    })) || []),
                                                                                    ...field?.options?.filter(
                                                                                        opt =>
                                                                                            opt?.label !==
                                                                                            commonFieldOptionEnums.CONNECTED
                                                                                    )
                                                                                ]}
                                                                                dropdownSettings={{
                                                                                    hasLockedFields: true
                                                                                }}
                                                                                requiredType="mandatory"
                                                                                assistiveText=""
                                                                                varName="value"
                                                                                value={field.value}
                                                                                onTextChange={e => {
                                                                                    const selectedValue = e?.value;
                                                                                    const isCreateNewConnectField =
                                                                                        selectedValue ===
                                                                                        commonFieldOptionEnums.CONNECTED;
                                                                                    const isPredefined =
                                                                                        selectedValue ===
                                                                                        commonFieldOptionEnums.PREDEFINED;
                                                                                    const isConnectField =
                                                                                        e?.isConnectField;

                                                                                    if (isCreateNewConnectField) {
                                                                                        handleOpenConnectedFieldModal();
                                                                                        updateField(
                                                                                            stepIndex,
                                                                                            field.id,
                                                                                            "value",
                                                                                            undefined,
                                                                                            "",
                                                                                            true
                                                                                        );
                                                                                        return;
                                                                                    }

                                                                                    if (isPredefined) {
                                                                                        updateField(
                                                                                            stepIndex,
                                                                                            field.id,
                                                                                            "value",
                                                                                            selectedValue,
                                                                                            undefined,
                                                                                            true
                                                                                        );
                                                                                        return;
                                                                                    }

                                                                                    const key = isConnectField
                                                                                        ? fieldNameEnums.CONNECTED_FIELD
                                                                                        : fieldNameEnums.EXTRA_FIELD;
                                                                                    updateField(
                                                                                        stepIndex,
                                                                                        field.id,
                                                                                        "value",
                                                                                        selectedValue,
                                                                                        key,
                                                                                        true
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        {field?.value === "Predefined" ? (
                                                                            <FormField
                                                                                type="text"
                                                                                title="Predefined Value"
                                                                                tooltip="Predefined Value"
                                                                                requiredType="mandatory"
                                                                                assistiveText=""
                                                                                varName="predefinedValue"
                                                                                value={field?.predefinedValue}
                                                                                onTextChange={e =>
                                                                                    updateField(
                                                                                        stepIndex,
                                                                                        field.id,
                                                                                        fieldNameEnums.PREDEFINED_FIELD,
                                                                                        e,
                                                                                        fieldNameEnums.PREDEFINED_FIELD
                                                                                    )
                                                                                }
                                                                            />
                                                                        ) : null}

                                                                        <div
                                                                            className="cursor-pointer p-absolute"
                                                                            style={{
                                                                                right: "0px",
                                                                                top: "19px",
                                                                                padding: "2px"
                                                                            }}>
                                                                            <div>
                                                                                <div
                                                                                    className="table-list-action-dropdown"
                                                                                    onClick={() =>
                                                                                        removeField(stepIndex, field.id)
                                                                                    }>
                                                                                    <div className="frame-74">
                                                                                        <div className="align-items-center justify-center gap-4px p-4px">
                                                                                            <img
                                                                                                className="trash-01"
                                                                                                src={deleteIcon}
                                                                                                alt=""
                                                                                                height={"20px"}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {field.type === "Array Fields" && (
                                                                        <>
                                                                            {field?.arrayFields?.map(subField => (
                                                                                <ArrayFields
                                                                                    key={subField.id}
                                                                                    subField={subField}
                                                                                    stepIndex={stepIndex}
                                                                                    dataTypes={dataTypes}
                                                                                    updateArraySubField={
                                                                                        updateArraySubField
                                                                                    }
                                                                                    parentFieldId={field.id}
                                                                                    dropdownData={uniqueOptions}
                                                                                    parentField={field}
                                                                                    removeArraySubField={
                                                                                        removeArraySubField
                                                                                    }
                                                                                    handleOpenConnectedFieldModal={
                                                                                        handleOpenConnectedFieldModal
                                                                                    }
                                                                                    inputFields={inputFields}
                                                                                    outputFields={outputFields}
                                                                                />
                                                                            ))}
                                                                        </>
                                                                    )}
                                                                </Fragment>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="frame-1000011386">
                                            <div
                                                className="btn-sm-special"
                                                onClick={() =>
                                                    addField(stepIndex, category, calledFromEnums.AUTH_POPUP)
                                                }>
                                                <img className="plus" src={plus} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="line-4"></div>
                                </div>
                            );
                        })}
                    </div>
                )}
                {authDetails?.type === authTypeEnums.BEARER_TOKEN && (
                    <FormField
                        type="text"
                        title="Value"
                        tooltip="Value"
                        assistiveText=""
                        requiredType="mandatory"
                        varName="value"
                        value={authDetails?.token}
                        onTextChange={e => {
                            handleAuthChange("token", e);
                        }}
                    />
                )}
            </StepFormStyle>
        );
    });
};

export default AuthorizationPopup;
